import React, { useCallback, useContext, useEffect, useState } from "react";
import { Card } from "@mui/material";
import StockAuditActors from "./StockAuditActors";
import StockAuditProductGrid from "./StockAuditProductGrid";
import classes from "./StockAudit.module.css";
import Fade from "@mui/material/Fade";
import Shortcut from "../framework/Shortcut";
import GlobalContext from "../framework/GlobalContext";
import { useDispatch, useSelector } from "react-redux";
import { newProduct } from "../utils/constant";
import { StockAuditContextProvider } from "./StockAuditContext";
import moment from "moment";

const StockAudit = () => {
  const [actorsAutocompleteOpen, setActorsAutocompleteOpen] = useState(false);
  const { props } = useSelector(
    (state) => state.commonReducer.tabs[state.commonReducer.activeTabIndex]
  );
  const {
    actors: { startDate },
  } = useSelector(
    (state) => state.commonReducer.tabs[state.commonReducer.activeTabIndex]
  );
  const { autocompleteOpen, setCurrentComponent, currentComponent } =
    useContext(GlobalContext);
  const dispatch = useDispatch();
  const focusField = useCallback((id) => {
    document.getElementById(id).focus({ preventScroll: true });
  }, []);
  const stockAuditListener = useCallback(
    (event) => {
      if (currentComponent?.startsWith("list_nav")) return;
      const key = event.key?.toLowerCase();
      const altKey = event.altKey;
      if (altKey) {
        if (key === "p") {
          focusField("sales_patient");
          return;
        }
        if (key === "t") {
          focusField("sales_doctor");
          return;
        }
        if (key === "d") {
          focusField("sales_discount");
          return;
        }
        if (key === "i") {
          focusField("sales_invoice");
          return;
        }
        if (key === "r") {
          focusField("sales_remarks");
          return;
        }
      }
    },
    [currentComponent, focusField]
  );
  useEffect(() => {
    if (!autocompleteOpen)
      document.addEventListener("keyup", stockAuditListener, false);
    return () => {
      document.removeEventListener("keyup", stockAuditListener, false);
    };
  }, [autocompleteOpen, stockAuditListener]);
  useEffect(() => {
    return () => setCurrentComponent(null); //on unmount
  }, [setCurrentComponent]);
  useEffect(() => {
    if (props?.products) {
      dispatch({
        type: "update_medicine_grid",
        payload: [newProduct, ...props.products],
      });
      dispatch({ type: "update_props", payload: null });
    }
  });
  return (
    <StockAuditContextProvider>
      <Fade in={true} timeout={100}>
        <Card
          sx={{
            width: "100%",
            height: "100%",
            padding: "5px 5px 0px 5px",
            borderRadius: 0,
          }}
        >
          <div
            className={`${classes["stock-audit-medicine-bill-parent-wrapper"]} 
         ${actorsAutocompleteOpen ? classes["hide"] : null}
         `}
          >
            <Card
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: 0,
                overflow: "visible",
              }}
            >
              <StockAuditProductGrid />
            </Card>
          </div>
          <Card
            sx={{
              width: "100%",
              height: "80px",
              border: 1,
              background: "#E0E0E0",
              borderRadius: 1,
              transition: "500ms width ease-in",
              padding: "0 5px",
            }}
          >
            <StockAuditActors
              autocompleteOpen={(isActorsAutocompleteOpen) => {
                setActorsAutocompleteOpen(isActorsAutocompleteOpen);
              }}
            />
          </Card>
          <div className={classes["stock-audit-footer"]}>
            <div className={classes["stock-audit-footer-left-shortcuts"]}>
              {/* <Shortcut keys={["Ctrl", "L"]} label={"Shortcut List"} /> */}
              {/* <Shortcut keys={["Ctrl", "Space"]} label={"Search"} /> */}

              {/* <Shortcut
                keys={[{ image: youtubeIcon }]}
                label={"Tutorial (Ctrl+T)"}
              /> */}
            </div>

            <div
              className={classes["stock-audit-footer-right-shortcuts"]}
            ></div>
          </div>
        </Card>
      </Fade>
    </StockAuditContextProvider>
  );
};
export default StockAudit;
